/**
 * Invoice statement type status code class.
 */
export enum StatementType {
  CREDIT_NOTE = "CREDIT_NOTE",
  INVOICE = "INVOICE",
  PREPAID_STATEMENT = "PREPAID_STATEMENT",
  STATEMENT = "STATEMENT",
}
